module.exports = __webpack_public_path__ + "static/img/01.5323dce2.png";